import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";
import IceButton from "../../components/Button";
import TextField from "@mui/material/TextField";



export default function DialogParkSrcFeat(props: any) {

    let {user, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    let {parkObj, setParkObj, projUID, refreshFunc} = props
    // console.log(parkObj)

    let mapStatus = parkObj?.srcFeatObj?.mapStatus
    // console.log('--->', mapStatus)

    function handlePark() {

        fetch(`${serverIP}/parksrcfeat/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({
                user: user.username,
                projUID: projUID,
                srcFeatUID: parkObj.srcFeatObj?.features?.featUID,
                comment: parkComment,
                mapStatus: mapStatus
            }),
        }).then(res => res.json())
            .then((data) => {
                // if (data.code === 204) {
                    setActionStatus(data.code)
                    // })
                    // console.log('Success')
                // }
                // console.log(data)
            })

        setParkObj((prev: any) => {
            return {...prev, isOpen: false, srcFeatObj: {}}
        }) // a dialog must be closed anyway after Save is clicked

        setParkComment("")
    }

    const [actionStatus, setActionStatus] = useState(0)

    useEffect(() => {
        if (actionStatus > 0) {
            refreshFunc()
            setActionStatus(0)
        }
    }, [actionStatus])


    const [parkComment, setParkComment] = useState<any>("")

    function handleParkComment(event: any) {
        setParkComment(event.target.value)
        // console.log(event.target.value)
    }

    let dialContentRes = undefined
    if (mapStatus == 'mapped') {
        dialContentRes = (
            <>
                <DialogTitle sx={{paddingLeft: "0 !important"}}>Parking source feature</DialogTitle>
                <DialogContentText style={{fontSize: '0.9rem'}}>
                    This feature <strong>{parkObj.srcFeatObj.features?.featName}</strong> in the
                    category <strong>"{parkObj.srcFeatObj?.catName}"</strong> is mapped ! <br/>
                    Mapped features which take part in mappings can't be parked. <br/><br/>
                    Please remove existing mappings for this feature and then proceed with parking.
                </DialogContentText>
            </>
        )
    } else if (mapStatus == 'not mapped') {
        dialContentRes = (
            <>
                <DialogTitle sx={{paddingLeft: "0 !important"}}>Parking source feature</DialogTitle>
                <DialogContentText style={{fontSize: '0.9rem'}}>
                    You are about to park the source
                    feature <strong>{parkObj.srcFeatObj.features?.featName} (ID: {parkObj.srcFeatObj.features?.featID}</strong>)
                    in the category <strong>"{parkObj.srcFeatObj?.catName}"</strong>. <br/>
                    <br/>
                    You may specify the reason for parking the feature (optionally):
                </DialogContentText>

                {/* a feature can only be parked if it's "not mapped". If it's "parked" or "mapped" then it CANNOT be parked.  */}
                <TextField
                    sx={{backgroundColor: "#f2f2f2", borderRadius: "5px", border: "none !important"}}
                    value={parkComment}
                    autoFocus
                    margin="dense"
                    id="park-comment"
                    // label="type here:"
                    type="text"
                    fullWidth
                    variant="standard"
                    multiline
                    minRows={2}
                    maxRows={4}
                    onChange={(event: any) => handleParkComment(event)}
                />
            </>
        )
    } else if (mapStatus == 'parked') {
        dialContentRes = (
            <>
                <DialogTitle sx={{paddingLeft: "0 !important", paddingTop: "0 !important"}}>Unparking source feature</DialogTitle>
                <DialogContentText style={{fontSize: '0.9rem'}}>
                    You are about to unpark the source
                    feature <strong>{parkObj.srcFeatObj.features?.featName} (ID: {parkObj.srcFeatObj.features?.featID}</strong>)
                    in the category <strong>"{parkObj.srcFeatObj?.catName}"</strong>. <br/>
                    <br/>

                    {parkObj.srcFeatObj?.parkData && <>
                        <strong>Parking data:</strong>
                        <div className="park-data">
                            <div className="cell">Parked by:</div>
                            <div className="cell">{parkObj.srcFeatObj?.parkData.parkedBy}</div>
                            <div className="cell">Date of park:</div>
                            <div className="cell">{parkObj.srcFeatObj?.parkData.date}</div>
                            {parkObj.srcFeatObj.parkData?.comment && <>
                                <div className="cell">Parking comment:</div>
                                <div className="cell">{parkObj.srcFeatObj.parkData?.comment}</div>
                            </>}
                        </div>
                    </>}

                    Please confirm the action.
                </DialogContentText>
            </>
        )
    }
    // console.log(dialContentRes)


    return (

        <Dialog
            open={parkObj.isOpen}
            onClose={() => setParkObj((prev: any) => {
            return {...prev, isOpen: false, srcFeatObj: {} }})}
        >

            <DialogContent>{dialContentRes}</DialogContent>

            <DialogActions sx={{marginBottom: "10px", marginRight: "10px !important"}}>

                {mapStatus !== 'mapped' && <IceButton
                    type={userPermissions.canEdit ? "primary" : "secondary"}
                    text={mapStatus == 'parked' ?  "Unpark" : "Park"}
                    onclick={userPermissions.canEdit ? handlePark : undefined}/>
                }

                <IceButton
                    type="delete"
                    text={mapStatus == 'mapped' ? "Close" : "Cancel"}
                    onclick={() => setParkObj((prev: any) => {
                    return {...prev, isOpen: false, srcFeatObj: {} } })}
                />
            </DialogActions>

        </Dialog>
    )
}
